
import EntityCard from "@/components/common/EntityCard";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";
import UiLazyImg from "~/components/UI/UiLazyImg.vue";
import UiButton from "~/components/UI/UiButton.vue";
export default {
  name: "EntityBlock",
  components: {
    UiLazyImg,
    UiSwiperCarousel,
    EntityCard,
    UiButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    blockData: {
      type: Array,
      default: () => [],
    },
    pageData: {
      type: Object,
      default: () => {},
    },
    block: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    position() {
      return this.data?.card_content_position || "left";
    },
    buttonStyle() {
      switch (this.position) {
        case "left":
          return { marginLeft: "0", marginRight: "auto" };
        case "right":
          return { marginLeft: "auto", marginRight: "0" };
        case "center":
        default:
          return { marginLeft: "auto", marginRight: "auto" };
      }
    },
  },
};
